import PropTypes from 'prop-types';
import ProfileSection from './ProfileSection';

const Header = ({ open, sidebarWidth, collapsed }) => {
  return (
    <header 
      className="fixed top-0 h-16 border-b bg-background z-30 transition-all duration-300"
      style={{
        left: open ? `${sidebarWidth}px` : '0',
        right: '0'
      }}
    >
      <div className="flex h-full items-center px-4 gap-4">
        {collapsed && (
          <img 
            src="/OptiHomecare.png" 
            alt="OptiHHCP Logo" 
            className="h-8 w-auto object-contain"
          />
        )}
        <div className="flex-1" />
        <ProfileSection />
      </div>
    </header>
  );
};

Header.propTypes = {
  open: PropTypes.bool,
  sidebarWidth: PropTypes.number,
  collapsed: PropTypes.bool
};

export default Header;